import {inject} from '@angular/core';
import {Route} from '@angular/router';
import {Observable} from 'rxjs';
import {FeatureFlagService} from '@brunata-angular/util';
import {consumerResolver} from '@shared/route-utils';
import {ReactOnlineIframeComponent} from 'src/app/building/react-online-iframe/react-online-iframe.component';

/**
 * The Angular consumer profile, registered with a full path immediately ahead of the React route
 * it replaces, so that React route can stay exactly as it is.
 *
 * It is deliberately not nested inside the React branch. `ReactOnlineIframeComponent` has no
 * `<router-outlet>`, so a page below one never renders; and un-nesting the iframe to make room
 * moves the route that React's `postMessage` navigation resolves against, which silently breaks
 * React's own links (it posts paths relative to wherever the live iframe sits).
 */
export const consumerProfileRoute = (path: string): Route => ({
    path,
    // Two of these sit directly under the building route, where SubMenuComponent would otherwise
    // render their raw path as a building tab.
    data: {hide: true},
    canMatch: [
        (): Observable<boolean> =>
            inject(FeatureFlagService).isFeatureFlagEnabled$(
                'agi-19754-online-consumer-details-view',
            ),
    ],
    resolve: {breadcrumb: consumerResolver},
    // The page re-navigates to itself after a rename so the heading picks up the new name.
    runGuardsAndResolvers: 'always',
    children: [
        {
            path: '',
            pathMatch: 'full',
            loadComponent: () =>
                import('./consumer-profile.component').then(
                    module => module.ConsumerProfileComponent,
                ),
        },
        {
            path: 'register-move-out',
            component: ReactOnlineIframeComponent,
            data: {
                module: 'residents',
                key: 'actions_registerMoveOut',
                reactRoute:
                    'buildings/{buildingno}/residents/all-residents/{consumerid}/register-move-out?locationId={locationid}',
            },
        },
    ],
});
